import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-x3 sm:px-x4" }
const _hoisted_2 = { class: "text-center -mt-10 mb-x2 md:mb-x3" }
const _hoisted_3 = { class: "text-center mb-x2 md:mb-x3" }
const _hoisted_4 = { class: "px-x3 mt-50 text-center flex flex-col items-center sm:px-x4 sm:flex-row sm:justify-between" }
const _hoisted_5 = { class: "c-magic-line" }
const _hoisted_6 = { class: "c-magic-line" }

import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import useProductDetailUpsell from '@/shared/product/upsell/useProductDetailUpsell';
import { computed, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import ProductDetailUpsellItems from '@/shared/product/upsell/ui/ProductDetailUpsellItems.vue';
import authStore from '@/shared/auth/auth.store';
import BasketLink from '@/shared/navigation/BasketLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailUpsellOverlay',
  setup(__props) {

const router = useRouter();
const { shouldShowUpsellItems, clearUpsellItems } = useProductDetailUpsell();
const labels = useBlockLabels();

const powerStepHeaderLabel = computed(() => authStore.isSignedInAsPartner ? labels.b2BPowerStepHeaderLabel : labels.b2CPowerStepHeaderLabel);
const powerStepTextLabel = computed(() => authStore.isSignedInAsPartner ? labels.b2BPowerStepTextLabel : labels.b2CPowerStepTextLabel);

const unRegisterNavigationGuard = router.beforeEach((to, from, next): void => {
    clearUpsellItems();
    next(true);
});

onUnmounted(() => {
    unRegisterNavigationGuard();
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(shouldShowUpsellItems),
    class: "fixed inset-0 py-x4 mx-auto z-1 bg-white max-w-925 pt-60 sm:relative sm:inset-auto sm:w-screen-90 sm:h-auto md:w-screen-80",
    onClose: _unref(clearUpsellItems)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(powerStepHeaderLabel)), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(powerStepTextLabel)), 1)
      ]),
      _createVNode(ProductDetailUpsellItems),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "flex flex-nowrap items-center mb-20 sm:mb-0",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(clearUpsellItems) && _unref(clearUpsellItems)(...args)), ["prevent"]))
        }, [
          _createVNode(_component_c_icon, {
            name: "icon-arrow-small",
            class: "rotate-180 w-8 h-8 mt-1 mr-6 xl:h-10 xl:mr-8 xl:-mt-1"
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(labels).continueShoppingLink), 1)
        ]),
        _createVNode(BasketLink, null, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(labels).continueCheckoutButton), 1),
            _createVNode(_component_c_icon, {
              name: "icon-arrow-small",
              class: "w-8 h-8 -mt-1 ml-6 xl:h-10 xl:ml-8"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["is-open", "onClose"]))
}
}

})